export class Contato {
  constructor(
    public Setor: string,
    public NumFone: string,
    public NumWatts: string,
    public NumWattsFormatado: string,
    public OmniChat: string
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/_shared/contato/contato.ts